document.addEventListener('DOMContentLoaded', function() {
  
  // 1. 【关键检查】如果页面上有 bundle 组件，这个脚本就直接退出，防止冲突
  if (document.querySelector('addon-bundler')) {
    // console.log('Bundle组件存在，标准监听脚本退出。');
    return;
  }

  const mainProduct = document.getElementById('global-product-data');
  const mainProductQty = document.getElementById(`quantity-${mainProduct.dataset.section}`)
  const variantMetaData = JSON.parse(document.getElementById('variantMetaData').textContent) || {}

  // 如果连主产品数据都没有，说明可能不是产品页，退出
  if (!mainProduct) return;

  // --- 核心逻辑：计算并广播 ---
  function dispatchStandardUpdate(qtyChange = true) {
    const price = parseFloat(mainProduct.dataset.price);
    const comparePrice = parseFloat(mainProduct.dataset.comparePrice) || price;
    const off =  parseFloat(mainProduct.dataset.variantOff) * 100 || parseFloat(mainProduct.dataset.off) * 100 || 0
    // 数量默认为 1
    let mainQty = mainProductQty ? (parseInt(mainProductQty.value) || 1) : 1;
    if(mainProductQty) {
      let qtyIpt = mainProductQty.querySelector('input')
      if(qtyIpt) mainQty = qtyChange ? parseInt(qtyIpt.value) || 1 : 1
    }
    // 计算总价
    const totalPrice = (price - off) * mainQty;
    const totalComparePrice = comparePrice * mainQty;
    // 构建完全一致的数据结构
    const eventData = {
      items: [{
        id: mainProduct.value,
        variantTitle: mainProduct.dataset.variantTitle,
        featuredImage: mainProduct.dataset.featuredImage,
        price: price - off,
        quantity: mainQty,
        comparePrice,
        title: mainProduct.dataset.havebundle ? document.querySelector('bundle-variant-picker input:checked')?.value.split('(')[0] : mainProduct.dataset.title
      }],
      totalComparePrice,
      totalPrice: totalPrice,
      save: totalComparePrice - totalPrice,
      totalCount: 1
    };
    
    // 发送同样的事件
    document.dispatchEvent(new CustomEvent('add-ons:update', {
      detail: eventData,
      bubbles: true
    }));
  }
  function addSizeToImageUrl(url, size = '_128x') {
    if (!url || typeof url !== 'string') return url;
    
    // 匹配常见图片格式扩展名
    return url.replace(/\.(png|jpg|jpeg|gif|webp|bmp|svg)(?=\?|$)/i, `${size}.$1`);
  }
  // --- 绑定事件 ---

  // 1. 监听全局变体切换 (更新 input 数据)
  document.addEventListener('product:variant-change', (e) => {
    const variant = e.detail.variant;
    console.log(variant, 'standard-product-monitor');
    
    if (!variant.available) return;
    // 1. 更新主产品 hidden input 的数据
    
    if(variantMetaData[variant.id] && variantMetaData[variant.id].off) {
        mainProduct.dataset.variantOff = variantMetaData[variant.id].off
    }else {
        mainProduct.dataset.variantOff = mainProduct.dataset.off
    }
    mainProduct.dataset.variantTitle = variant.title
    
    mainProduct.value = variant.id;
    // Shopify 事件里的 price 通常是“分” (2999)，直接存进去
    mainProduct.dataset.price = variant.price; 
    mainProduct.dataset.comparePrice = variant.compare_at_price; 
    mainProduct.dataset.featuredImage = addSizeToImageUrl(variant.featured_image.src) || mainProduct.dataset.featuredImage;
    // 立即广播
    dispatchStandardUpdate(false);
  });

  // 2. 监听数量变化
  if (mainProductQty) {
    mainProductQty.addEventListener('change', dispatchStandardUpdate);
  }
  // 3. 页面加载完，先广播一次（初始化底部栏价格）
  dispatchStandardUpdate();
});